<div class="px-3">


  <div class="rem-text-default mb-6">
    <div class="flex align-items-center">
      <icon-button
        *ngIf="isSettlementBalanceTypeView"
        pTooltip='Back'
        tooltipPosition='left'
        (click)="onCloseBalanceTypeView()"
        [icon]="'chevron-left'"
        class="pr-2"
      />
      <div class="rem-bg-light px-3 py-3 mr-2">
        <i class="pi pi-users font-medium text-xl"></i>
      </div>
      @if(!isSettlementBalanceTypeView){
        <div>
          <div class="text-2xl font-medium">Settlement</div>
          <div class="text-right mt-2"></div>
        </div>
      } @else {
        <div>
          <div class="text-2xl font-medium">Settlement - {{balanceTypeViewHeading}} Type</div>
          <div class="text-right mt-2">{{balanceTypeViewTtitle}}</div>
        </div>
      }
      
    </div>
  </div>


  <div *ngIf="!isSettlementBalanceTypeView" class="flex justify-content-between">
    <div class="flex flex-row gap-3 align-items-center">
      <creditor-autocomplete
        (onSelect)="onSelectCreditor($event)"
      ></creditor-autocomplete>

      <p-floatLabel>
        <p-dropdown class="w-full" id="settlementTypeOptions" [options]="settlementStatusOptions" [(ngModel)]="filterSettlementStatus" (onChange)="this.getSettlementTableData($event.value)" optionLabel="label" optionValue="id" placeholder="Select Type"></p-dropdown>
        <label for="creditors">Status</label>
      </p-floatLabel>
         
    </div>

    <div>
      <remitter-button   
        (click)="onOpenSideBar()" 
        label='Add New'
        icon='plus'
        severity='info'
       >     
      </remitter-button>
    </div>
   
</div>
<div *ngIf="!isSettlementBalanceTypeView" class="mt-4">
    <div 
      *ngIf="!hasTableData && hasClickedSearch"
      style="text-align:center; margin-top:9rem; color: #336699; font-size: 1rem;">
            🚫 No records found for {{ creditorCompanyName }}
    </div>
    <p-table 
      *ngIf="hasTableData"
      [value]="filteredSettlementConfigs" [tableStyle]="{ 'min-width': '50rem' }" [paginator]="true"
    [rows]="10" [rowsPerPageOptions]="[10, 20, 30]" >
        <ng-template pTemplate="header">
            <tr class="text-xs">
                <th>Creditor Id</th>
                <th>Creditor Name</th>
                <th>Settlement Type</th>    
                <th>Settlement Status</th>         
                <!-- <th>Last Updated Date</th>          -->
                <th>Action</th>         
            </tr>
        </ng-template>

        <ng-template pTemplate="body" let-settlement>
            <tr class="text-xs">
                <td>{{ settlement.CreditorId }}</td>
                <td>{{ settlement.CompanyName }}</td>
                <td>{{ getSettlementTypeLabel(settlement.SettlementTypeId) }}</td>
                <td>{{ settlement.IsSettlementPaymentEnabled ? 'Active' : 'Inactive'}}</td>
                <!-- <td>{{ settlement.DateFormat }}</td> -->
                <td>
                    <div class="flex align-items-center gap-2">
                        <icon-button
                        pTooltip="Edit"
                        tooltipPosition='left'
                        (click)="onOpenSideBar({
                          id: settlement.Id,
                          formSelectedCreditorId: settlement.CreditorId,
                          formCreditorCompanyName: settlement.CompanyName,
                          settlementTypeId: settlement.SettlementTypeId,
                          settlementTypeStatus: settlement.IsSettlementPaymentEnabled
                        })"
                        [icon]="'pencil'"
                        [styleClass]="'mr-1'"
                       />
                      <button 
                        [disabled]="!getSettlementTypeLabel(settlement.SettlementTypeId)" 
                        pTooltip="Settlement Plan" 
                        tooltipPosition='left' 
                        class="rem-bg-light border-round-md py-2 px-2 cursor-pointer mr-1 border-none" 
                        [ngClass]="!getSettlementTypeLabel(settlement.SettlementTypeId) ? '' : 'rem-text-default'"
                        (click)="onOpenBalanceTypeView(settlement)"
                      >
                        <i [ngClass]="'text-xs pi pi-bars'"></i>
                      </button>
                      <p-inputSwitch (ngModelChange)="onSave(extractId(settlement.CreditorId), $event, settlement.SettlementTypeId)" [ngModel]="settlement.IsSettlementPaymentEnabled === 1" />
                      </div>
                </td>       
            </tr>
        </ng-template>
    </p-table>
</div>

<div *ngIf="isSettlementBalanceTypeView">
  <div class="info-container">
    <div class="row mt-4">
      <div class="label">Creditor Id</div>
      <div class="colon">:</div>
      <div class="value">{{settlementBalanceTypeViewData.CreditorId}}</div>
    </div>

    <div class="row">
      <div class="label">Creditor Name</div>
      <div class="colon">:</div>
      <div class="value">{{settlementBalanceTypeViewData.CompanyName}}</div>
    </div>
  </div>

  <div class="mt-4">
    <ng-container *ngIf="settlementBalanceTypeViewData?.SettlementTypeId != 2">
      <p-tabView [(activeIndex)]="activeTabIndex" *ngIf="tabs && tabs.length > 0">
        <p-tabPanel *ngFor="let tab of tabs; trackBy: trackByTab" [header]="tab.title">
            <div>
              <p-table [value]="tab.content" [tableStyle]="{ 'min-width': '50rem' }"  [scrollable]="true" scrollHeight="400px">
                <ng-template pTemplate="header">
                    <tr class="text-xs">
                        <th>Min Amount</th>
                        <th>Max Amount</th>
                        <th>Percentage of Balance (%)</th>    
                        <th>Balance Discount Offered (%)</th>      
                    </tr>
                </ng-template>

                <ng-template pTemplate="body" let-data>
                    <tr class="text-xs">
                      <td>
                        <p-floatLabel>
                          <input [(ngModel)]="data.MinAmount" type="number" [disabled]="data.isEditDisable" class="w-full" pInputText id="MinAmount" placeholder="Min Amount" />
                        </p-floatLabel>
                      </td>
                      <td>
                        <p-floatLabel>
                          <input [(ngModel)]="data.MaxAmount" type="number" [disabled]="data.isEditDisable" class="w-full" pInputText id="MaxAmount" placeholder="Max Amount" />
                        </p-floatLabel>
                      </td>
                      <td>
                        <p-floatLabel>
                          <input [(ngModel)]="data.SettlementPercentage" type="number" [disabled]="data.isEditDisable" class="w-full" pInputText id="SettlementPercentage" placeholder="Percentage of Balance" />
                        </p-floatLabel>
                      </td>
                      <td>
                          <div class="flex align-items-center gap-2">
                            <p-floatLabel>
                              <input [ngModel]="100 - data.SettlementPercentage" [disabled]="true" class="w-full" pInputText id="SettledPercentage" placeholder="Balance Discount Offered" />
                            </p-floatLabel>
                            <icon-button
                              *ngIf="data.isEditDisable"
                              pTooltip="Edit"
                              tooltipPosition='left'
                              (click)="data.isEditDisable = false"
                              [icon]="'pencil'"
                              [styleClass]="'mr-1'"
                            /> 
                            <icon-button
                              *ngIf="!data.isEditDisable && data.Id"
                              pTooltip="Update"
                              tooltipPosition='left'
                              (click)="updateTabsTableRow(data);data.isEditDisable = true"
                              [icon]="'send'"
                              [styleClass]="'mr-1'"
                            /> 
                            <icon-button
                              *ngIf="!data.isEditDisable && !data.Id"
                              pTooltip="Save"
                              tooltipPosition='left'
                              (click)="updateTabsTableRow(data);data.isEditDisable = true"
                              [icon]="'send'"
                              [styleClass]="'mr-1'"
                            /> 
                            <div *ngIf="data.Id" [ngClass]="'rem-bg-light rem-text-default border-round-md py-1 px-2 cursor-pointer mr-1 text-danger'" 
                              pTooltip="Delete"
                              tooltipPosition='left'
                              (click)="deleteTableRow(data)">
                              <i [ngClass]="'text-xs pi pi-trash'"></i>
                            </div>
                            <p-inputSwitch (ngModelChange)="onOfferStatusChange(data.Id, $event)" [ngModel]="data.IsActive === 1" />
                          </div>
                      </td>       
                    </tr>
                </ng-template>
                <ng-template pTemplate="emptymessage">
                  <tr>
                    <td colspan="4" class="text-center text-sm py-3">
                      No data available. Click "Add Row" to create one.
                    </td>
                  </tr>
                </ng-template>
              </p-table>
            </div>
        </p-tabPanel>
      </p-tabView>

      <div *ngIf="!tabs || tabs.length === 0" class="text-center py-4 text-sm">
        No data available for this settlement type.
      </div>
    </ng-container>

    <div *ngIf="settlementBalanceTypeViewData?.SettlementTypeId == 2">
      <p-table [value]="tableData" [tableStyle]="{ 'min-width': '50rem' }" [scrollable]="true" scrollHeight="400px">

        <ng-template pTemplate="header">
          <tr class="text-xs">
            <th>Min Days</th>
            <th>Max Days</th>
            <th>Percentage of Balance (%)</th>    
            <th>Balance Discount Offered (%)</th> 
          </tr>
        </ng-template>

        <ng-template pTemplate="body" let-data>
          <tr class="text-xs">
            <td>
              <p-floatLabel>
                <input [(ngModel)]="data.MinDurationDays" [ngModelOptions]="{ standalone: true }" type="number" [disabled]="data.isEditDisable" class="w-full" pInputText id="MinDurationDays" placeholder="Min Days" />
              </p-floatLabel>
            </td>
            <td>
              <p-floatLabel>
                <input [(ngModel)]="data.MaxDurationDays" [ngModelOptions]="{ standalone: true }" type="number" [disabled]="data.isEditDisable" class="w-full" pInputText id="MaxDurationDays" placeholder="Max Days" />
              </p-floatLabel>
            </td>
            <td>
              <p-floatLabel>
                <input [(ngModel)]="data.SettlementPercentage" [ngModelOptions]="{ standalone: true }" type="number" [disabled]="data.isEditDisable" class="w-full" pInputText id="SettlementPercentage" placeholder="Percentage of Balance" />
              </p-floatLabel>
            </td>
            <td>
                <div class="flex align-items-center gap-2">
                  <p-floatLabel>
                    <input [value]="100 - data.SettlementPercentage" [disabled]="true" class="w-full" pInputText id="SettledPercentage" placeholder="Balance Discount Offered" />
                  </p-floatLabel>
                  <icon-button
                    *ngIf="data.isEditDisable"
                    pTooltip="Edit"
                    tooltipPosition='left'
                    (click)="data.isEditDisable = false"
                    [icon]="'pencil'"
                    [styleClass]="'mr-1'"
                  /> 
                  <icon-button
                    *ngIf="!data.isEditDisable && data.Id"
                    pTooltip="Update"
                    tooltipPosition='left'
                    (click)="updateTabsTableRow(data);data.isEditDisable = true"
                    [icon]="'send'"
                    [styleClass]="'mr-1'"
                  /> 
                  <icon-button
                    *ngIf="!data.isEditDisable && !data.Id"
                    pTooltip="Save"
                    tooltipPosition='left'
                    (click)="updateTabsTableRow(data);data.isEditDisable = true"
                    [icon]="'send'"
                    [styleClass]="'mr-1'"
                  /> 

                  <div *ngIf="data.Id" [ngClass]="'rem-bg-light rem-text-default border-round-md py-1 px-2 cursor-pointer mr-1 text-danger'" 
                    pTooltip="Delete"
                    tooltipPosition='left'
                    (click)="deleteTableRow(data)">
                    <i [ngClass]="'text-xs pi pi-trash'"></i>
                  </div>
                  <p-inputSwitch (ngModelChange)="onOfferStatusChange(data.Id, $event)" [ngModel]="data.IsActive === 1" />
                </div>
            </td> 
          </tr>
        </ng-template>

        <ng-template pTemplate="emptymessage">
          <tr>
            <td colspan="4" class="text-center text-sm py-3">
              No data available. Click "Add Row" to create one.
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
    <div class="flex justify-content-start align-items-start mt-3">
      <remitter-button   
        (click)="onAddRow()" 
        label='Add Row'
        icon='plus'
        severity='info'
       >     
      </remitter-button>
    </div>
  </div>
</div>
</div>

<p-sidebar [(visible)]="isSideBarVisible" styleClass="w-4" position="right">
    <div class="bg-white shadow-3 border-round p-4">
      <div class="text-xl font-medium">{{editedId ? 'Update ' : 'Add New '}} Settlement</div>
      
      @if(!editedId){
        <div class="flex align-items-center mt-4 gap-2 justify-content-between">
          <creditor-autocomplete
            (onSelect)="onFormSelectCreditor($event)"
          ></creditor-autocomplete>
        </div>
      }

      <ng-container *ngIf="formSelectedCreditorId && formCreditorCompanyName">
        <div class="flex align-items-center justify-content-between mt-4 gap-2 pr-3 pl-3" style="color: black;font-weight: 600;">
          <div>Creditor Name</div>
          <div>Creditor ID</div>
        </div>
        <div class="flex align-items-center justify-content-between mt-1 gap-2 pr-3 pl-3">
          <div>{{formCreditorCompanyName}}</div>
          <div>{{formSelectedCreditorId}}</div>
        </div>
        <div class="mt-5">
          <p-floatLabel>
            <p-dropdown class="w-full" id="settlementTypeOptions" [options]="settlementTypeOptions" [(ngModel)]="settlementTypeId" optionLabel="label" optionValue="id" placeholder="Select Type"></p-dropdown>
            <label for="creditors">Settlement Type</label>
          </p-floatLabel>
        </div>   
        
        <div class="flex align-items-center mt-5 gap-2">
          <label>Status</label>
          <p-inputSwitch [(ngModel)]="settlementTypeStatus" />
        </div>
      
        <div class="flex justify-content-end mt-4">
          <remitter-button
            (click)="onSave(extractId(formSelectedCreditorId), settlementTypeStatus, settlementTypeId)" 
            label='Save'
            icon='send'
          >     
          </remitter-button>
        </div>
      </ng-container>

    </div>
  </p-sidebar>
